import React from "react";
import { Link } from "react-router-dom";

import useConvertSlug from "../../hooks/useConvertSlug";

import { ArrowRight } from "../../assets/svg";

const ItemLink = ({ obj, type }) => {
  const { convertToSlug } = useConvertSlug();

  return (
    <Link
      to={{
        pathname: `/spel/${convertToSlug(obj.title)}`,
        state: { type: obj.type },
      }}
      aria-label={obj.title}
      className={`list_item--link ${type}`}
    >
      {obj.title}
      <ArrowRight alt="" aria-hidden="true" />
    </Link>
  );
};

export default ItemLink;
